<mat-tab-group *ngIf="listeImageIsLoadet && listeStyleAxeGroupIsLoadet && listeStyleAxeIsLoadet" #tabStyleAxeGroup [(selectedIndex)]="indexStyleAxeGroup" >
    <mat-tab *ngFor="let styleAxeGroup of listeStyleAxeGroup">
        <ng-template mat-tab-label>
            <span (click)="setListeImageFiltred(styleAxeGroup)">{{styleAxeGroup.StyleAxeGroup_Name}}</span>
        </ng-template>
        <mat-tab-group #tabStyleAxe [(selectedIndex)]="indexStyleAxe" >
            <mat-tab *ngFor="let styleAxe of styleAxeGroup.listeStyleAxe ">
                <ng-template mat-tab-label>
                    <span (click)="setListeImageFiltred(styleAxe)">{{styleAxe.StyleAxe_Label}}</span>
                </ng-template>
            </mat-tab>
            
        </mat-tab-group>
    </mat-tab>
</mat-tab-group>
<div style="width: 100%;" class="display-flex">
    <div>
        <div class="biblioteque-img">
            <h4 class="text-align-center"><b>Bibliothèque</b></h4>
        </div>
        <div class="images-left">
            <mat-accordion>
                <mat-expansion-panel >
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <h5 class="text-align-center">Source d'inspiraton</h5>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <img class="img-left" [id]="'owner_img'+img" *ngFor="let img of [1,2,3,4,5,6,7,8,9,10,11,12]" [src]="'../../../assets/gallery/img'+ img + '.jpg'">
                </mat-expansion-panel>
            </mat-accordion>            
        </div>

    </div>
    <mat-card class="images-right">
        <div class="display-flex-end">
            <button id="btn-grid" class="active" (click)="showImageGrid()"  mat-icon-button >
                <mat-icon>grid_on</mat-icon>
            </button>
            <button id="btn-liste" class="inactive" (click)="showImageListe()"  mat-icon-button >
                <mat-icon>list</mat-icon>
            </button>
        </div>
        <div id="liste-drop-area" style="height: 100%;zoom: 120%;">
            <div class="display-flex">
                <div style="margin-right: 5px;">
                    <div class="display-flex">
                        <div>
                            <div style="text-align: center;margin-right: 2px;">
                                <mat-form-field   style="width: 100px;">
                                    <input matInput name="textDropArea1" [(ngModel)]="textDropArea1" placeholder="Tappez votre texte">
                                </mat-form-field>
                                <div id="drop-area-0" style="width: 160px;height: 125px;" class="drop-area"></div>
                            </div>
                            <div id="drop-area-1" style="width: 145px;height: 140px;margin-left: 15px;margin-top: 5px;" class="drop-area"></div>
                        </div>
                        <div>
                            <div id="drop-area-2" style="width: 175px;height: 325px;" class="drop-area"></div>
                        </div>
                    </div>
                    <div>
                        <div style="padding-top: 2px;" class="display-flex">
                            <div id="drop-area-3" style="width: 110px;height: 90px;margin-right: 2px;" class="drop-area"></div>
                            <div id="drop-area-4" style="width: 110px;height: 90px;margin-right: 2px" class="drop-area"></div>
                            <div id="drop-area-5" style="width: 110px;height: 90px;" class="drop-area"></div>
                        </div>
                        <div style="z-index: 10;position: relative;top: -25px;left: 90px;background: white;width: 150px;                text-align: center;">
                            <mat-form-field   style="width: 100px;">
                                <input matInput name="textDropArea1" [(ngModel)]="textDropArea1" placeholder="Tappez votre texte">
                            </mat-form-field>
                        </div>
                    </div>                
                </div> 
                <div style="margin-right: 5px;">
                    <div class="display-flex">
                        <div id="drop-area-6" style="width: 195px;height: 155px;margin-right: 10px;margin-left: 10px;" class="drop-area"></div>
                        <div>
                            <div id="drop-area-7" style="width: 165px;height: 155px;" class="drop-area"></div>
                            <div style="z-index: 10;position: relative;top: -30px;left: 0px;background: white;width: 150px;                text-align: center;">
                                <mat-form-field   style="width: 100px;">
                                    <input matInput name="textDropArea1" [(ngModel)]="textDropArea1" placeholder="Tappez votre texte">
                                </mat-form-field>
                            </div>      
                        </div>
                    </div>   

                    <div class="display-flex" style="margin-top: -25px;">
                        <div id="drop-area-7" style="width: 170px;height: 230px;margin-right: 10px;;" class="drop-area"></div>
                        <div id="drop-area-8" style="width: 175px;height: 230px;" class="drop-area"></div>
                    </div>
                </div> 
                <div>
                    <div style="text-align: center;margin-bottom: 2px;">
                            <mat-form-field   style="width: 100px;">
                                <input matInput name="textDropArea1" [(ngModel)]="textDropArea1" placeholder="Tappez votre texte">
                            </mat-form-field>
                        <div id="drop-area-9" style="width: 115px;height: 90px;" class="drop-area"></div>
                    </div>
                    <div id="drop-area-10" style="width: 115px;height: 145px;margin-bottom: 2px" class="drop-area"></div>
                    <div id="drop-area-11" style="width: 115px;height: 145px;margin-bottom: 2px" class="drop-area"></div>
                </div>               
            </div>



        </div>
        <div style="height: 100%;display: none;" id="liste-image-right">
            <ng-container *ngFor="let img of listeImageFiltred">
                <img style="width: 150px;"  [src]="imageDomainUpload + img.FilesStatic_FullName">

            </ng-container>
        </div>

    </mat-card>        

</div>
<ng-template #frmListeStyle>
    <div class="btn">
        <button   (click)="saveImage()" mat-raised-button class="colorGreen">
            <mat-icon>save</mat-icon>
            Enregistrer
        </button>
    </div>
    <div class="display-flex">
        <div>
            <div class="style-item" *ngFor="let styleAxeGroup of listeStyleAxeGroup">
                <mat-checkbox [(ngModel)]="styleAxeGroup.checked" (change)="onstyleAxeGroupChecked()">
                    {{styleAxeGroup.StyleAxeGroup_Name}}
                </mat-checkbox>
            </div>            
        </div>

        <div>
            <div class="style-item" *ngFor="let styleAxe of listeStyleAxeFiltred">
                <mat-checkbox [(ngModel)]="styleAxe.checked">
                    {{styleAxe.StyleAxe_Label}}
                </mat-checkbox>
            </div>
        </div>
    </div>
    

    
</ng-template>
<div style="display: none;" id="image-to-upload">

</div>
<img   id="kkkkk">
<div id="5555"></div>
<div id="6666"></div>